import { IconButton } from '@monorepo/shared/componentsV2/Button/IconButton';
import { VisuallyHidden } from '@monorepo/shared/componentsV2/VisuallyHidden';
import EyeClosedIcon from '@svg/eye-closed.svg';
import EyeOpenIcon from '@svg/eye-open.svg';
import React from 'react';
import styled from 'styled-components';
import { DisplayQueryColumn } from '@monorepo/shared/componentsV2/QueryResultsTable/resultsMapper';

const StyledIconButton = styled(IconButton)`
  position: absolute;
  top: -0.4rem;
  right: 0;

  & svg {
    width: 1rem;
    height: 1rem;
  }
`;

export function ViewColumnShowHideButton({
  column,
  disabled,
  onClick,
}: {
  column: DisplayQueryColumn;
  disabled: boolean;
  onClick: () => void;
}) {
  return (
    <StyledIconButton disabled={disabled} onClick={onClick}>
      {column.isHidden ? (
        <>
          <VisuallyHidden>Show Column: {column.columnLabel}</VisuallyHidden>
          <EyeOpenIcon />
        </>
      ) : (
        <>
          <VisuallyHidden>Hide Column: {column.columnLabel}</VisuallyHidden>
          <EyeClosedIcon />
        </>
      )}
    </StyledIconButton>
  );
}
